
import Button from '../../../../UI/Button'
import s from './index.module.css'
import Modal from '../../../../common/Modal'
import Select from '../../../../UI/Select'
import Task from '../../../../common/Task'
import { InputWhite } from '@UI/New/InputWhite'
import ButtonNew from '@UI/New/Button/Button'
import sProbe from '../probe.module.css'
const ProbeTasks = props => {
  return <>

    <div className={s.list}>
      {props.probeTask?.filter(task=>task.type != 'file-answer')
        ?.sort((a, b) => a.id - b.id)
        ?.map((item, idx) => <Task key={item.id ?? `dev-${item.devId}`} props={{ ...item, category: 'edit', 'direction_id': props.directionID }} setStatus={() => { }} title={idx + 1} saveLS={props.saveLS} moveLS={props.moveLS} removeLS={props.removeLS} cancelLS={props.cancelLS} staticData={props.staticData} />)}
    </div>

    <div className={sProbe.wrapper}>
      <InputWhite 
        type='number'
        className={s.inputNew}
        onChange={props?.setNumberOfTasksInPartC}
        value={props?.numberOfTasksInPartC}
        title='введите количество заданий в части C' />
      <ButtonNew
        className={sProbe.button}
        onClick={props?.saveNumberOfTasksInPartC}>
        Сохранить количество заданий в части C
      </ButtonNew>
    </div>

      <div className={s.list}>
          {props.probeTask
              ?.filter(task => task.type == 'file-answer')
              ?.sort((a, b) => a.id - b.id) // 🔥 сортировка по id
              ?.map((item, idx) => (
                  <Task
                      key={item.id ?? `dev-${item.devId}`}
                      props={{ ...item, category: 'edit', direction_id: props.directionID }}
                      setStatus={() => {}}
                      title={idx + 1}
                      saveLS={props.saveLS}
                      moveLS={props.moveLS}
                      removeLS={props.removeLS}
                      cancelLS={props.cancelLS}
                      staticData={props.staticData}
                  />
              ))}
      </div>

    <div className={s.bottomBtns}>
      <Button newDesign newDesignYellow action={() => props.setShow(true)}>Добавить задания 1-ой части</Button>
    </div>


    <Modal active={props.show} setActive={props.setShow}>
      <h2 className="modal__title">Создать новую задачу</h2>
      <div className={s.modalBody}> <Select {...props.bindType} /> </div>
      <Button styles='accent' action={props.onAdd}>Выбрать</Button>
    </Modal>
  </>
}

export default ProbeTasks
